import Image from "next/image";
import { useEffect, useState } from "react";
import cn from "clsx";
import { Content } from "@prismicio/client";
import { TitlePage } from "@components/commun";
import { PrismicRichText } from "@prismicio/react";
import {
  EGender,
  ETitleLineStyles,
  ICountry,
  TGender,
} from "@middleware/types";
import { BILAN_COUNT_STEPS } from "@middleware/constants";
import FeatureWoman from "@static/images/feature/feature-bilan-woman.png";
import FeatureMan from "@static/images/feature/feature-bilan-man.png";
import { useCustomer } from "@middleware/hooks";
import { BilanForm } from "./BilanForm/BilanForm";
import style from "./Bilan.module.scss";

interface Props {
  content: Content.PageBilanDocument;
  countries: ICountry[];
  phoneIsRequired?: boolean;
  gender?: TGender;
}
export const Bilan = ({
  content,
  countries,
  phoneIsRequired,
  gender,
}: Props) => {
  const bilanData = content.data.slices[0] as Content.BilanBlockSlice;
  const [currentStep, setCurrentStep] = useState(0);
  const currentStepPercent = (100 / BILAN_COUNT_STEPS) * (currentStep + 1);
  const [userEmail, setUserEmail] = useState<string>("");
  const { customer } = useCustomer();

  useEffect(() => {
    if (customer !== undefined) {
      setUserEmail(customer.email);
    }
  }, [customer]);

  return (
    <div className={style.bilan}>
      <div className="lk-wrap">
        <div className="lk-wrap-content">
          <div className={style.progress}>
            <span style={{ width: currentStepPercent + "%" }}>&nbsp;</span>
          </div>
          <div className={style.title}>
            <TitlePage underline={ETitleLineStyles.STYLE_2}>
              <PrismicRichText field={bilanData.primary.title} />
            </TitlePage>
          </div>
          {currentStep === 0 && (
            <div className={style.subtitle}>
              <PrismicRichText field={bilanData.primary.description} />
            </div>
          )}

          <div className={style.bilanForm}>
            <BilanForm
              phoneIsRequired={phoneIsRequired}
              questions={bilanData}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              countries={countries}
              userEmail={userEmail}
              gender={gender}
            />
          </div>
        </div>
      </div>
      <div className={cn(style.feature, style[gender ?? ""])}>
        <Image
          src={gender === EGender.MAN ? FeatureMan : FeatureWoman}
          fill
          style={{
            objectFit: "cover",
          }}
          alt=""
        />
      </div>
    </div>
  );
};
